import { GetBitlyAccountsQuery, useGetBitlyAccountsQuery, UtmInput } from '../models/graphql';
import { useSelectedOrganization } from './useSelectedOrganization';
import { useContext, useMemo } from 'react';
import { AppContext } from '../providers/AppProvider';
import { ApolloError } from '@apollo/client';

export type BasePostLinkData = {
  campaignTracking: boolean;
  shouldRemoveUtm: boolean;
  utmTracking: UtmInput;
  bitlyAccounts: GetBitlyAccountsQuery['workspace']['bitlyAccounts'];
  defaultBitly: GetBitlyAccountsQuery['workspace']['settings']['defaultBitly'];
};

export type PostLinkData = BasePostLinkData & {
  loading: boolean;
  error: ApolloError | undefined;
};

export const usePostLinkSettings = (): PostLinkData => {
  const { selectedWorkspace } = useSelectedOrganization();
  const { selectedWorkspaceId } = useContext(AppContext);
  const userSettings = selectedWorkspace?.settings;

  const {
    loading: bitlyLoading,
    data: bitlyAccountsdata,
    error: bitlyAccountsError
  } = useGetBitlyAccountsQuery({
    variables: {
      workspaceId: selectedWorkspaceId
    }
  });

  const utmTracking: UtmInput = useMemo(
    () => ({
      source: userSettings?.utm?.source ?? '',
      medium: userSettings?.utm?.medium ?? '',
      campaign: userSettings?.utm?.campaign ?? '',
      term: userSettings?.utm?.term ?? '',
      content: userSettings?.utm?.content ?? ''
    }),
    [userSettings]
  );

  const bitlySettings = useMemo(
    () => ({
      bitlyAccounts: bitlyAccountsdata?.workspace.bitlyAccounts || [],
      defaultBitly: bitlyAccountsdata?.workspace.settings.defaultBitly
    }),
    [bitlyAccountsdata]
  );
  const { bitlyAccounts, defaultBitly } = bitlySettings;

  const loading = bitlyLoading || (bitlyAccountsdata === undefined && !bitlyAccountsError);
  const error = bitlyAccountsError;
  return {
    campaignTracking: userSettings?.campaignTracking || false,
    shouldRemoveUtm: userSettings?.shouldRemoveUtm || false,
    utmTracking,
    bitlyAccounts,
    defaultBitly,
    loading,
    error
  };
};
